import React, { useState, useEffect } from "react";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import ClearButton from "../../../../../../components/ClearButton/ClearButton";
import { Button } from "@/components/ui/button";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

interface InvoiceListFiltersProps {
  filters: {
    searchTerm?: string;
  };
  onFilterChange: (searchTerm: string) => void;
  onExportCsv: () => void;
  isExporting: boolean;
}

const InvoiceListFilters: React.FC<InvoiceListFiltersProps> = ({
  filters,
  onFilterChange,
  onExportCsv,
  isExporting,
}) => {
  const [searchTerm, setSearchTerm] = useState(filters.searchTerm || "");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 500);

  useEffect(() => {
    onFilterChange(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const onClearSearch = () => {
    setSearchTerm("");
    onFilterChange("");
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="relative w-full max-w-md">
          <input
            className="px-3 py-2 pr-10 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary dark:bg-slate-800 dark:border-slate-700 dark:text-slate-100 dark:focus:ring-primary dark:focus:border-primary"
            onChange={onSearchInputChange}
            placeholder="Search by customer name or invoice number"
            type="text"
            value={searchTerm}
          />
          <ClearButton isVisible={!!searchTerm} onClick={onClearSearch} />
        </div>
        <Button disabled={isExporting} onClick={onExportCsv} variant="outline">
          <ArrowDownTrayIcon className="h-4 w-4 mr-2" />
          {isExporting ? "Exporting..." : "Export as .csv"}
        </Button>
      </div>
    </div>
  );
};

export default InvoiceListFilters;
